import React from 'react';
// import { render } from 'react-dom'
import PropTypes from 'prop-types';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { Paper } from '@material-ui/core';

// Make monochrome colors
/* var pieColors = (function () {
  var colors = ['#'],
      base = Highcharts.getOptions().colors[0],
      i;

  for (i = 0; i < 10; i += 1) {
      // Start out with a darkened base color (negative brighten), and end
      // up with a much brighter color
      colors.push(Highcharts.color(base).brighten((i - 3) / 7).get());
  }
  return colors;
}()); */

const optionsChart = ({ title, data }) => {
  return {
    chart: {
      //plotBackgroundColor: "#FFFFFF",
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: '70%',
      backgroundColor: "transparent",
      /* borderColor: '#EBBA95',
      borderRadius: 20,
      borderWidth: 2, */
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      style: {
        //fontWeight: 'bold',
        //fontFamily: 'Roboto-Bold'
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        colors: ['#b48519', '#2e2757', '#28bad8', '#96c7ee', '#adca6a', '#15709D', '#6FC0E4'],
        dataLabels: {
          enabled: false,
          format: '<b>{point.name}</b> ',
          distance: -50,
          borderColor: '#000000',
          shadow: true,
          // backgroundColor: '#ffffff'
        },
        showInLegend: true
      }
    },
    title: {
      text: title,
      style: {
        color: "#b48519"
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'top',
      itemStyle: {
        color: "#abacb7",
        fontSize: 10
      }
    },
    series: [{
      name: 'Monto',
      colorByPoint: true,
      data
    }],
    credits: {
      enabled: false
    }
  }
}

const Pie = ({ data }) => {
  //console.log(data)
  const options = optionsChart(data)
  return (
    <Paper elevation={0} style={{ padding: "8px 0px", margin:"-4px 0px", borderRight: 16, 
     borderRadius: "16px", }}>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
    </Paper>
  );
};

Pie.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Pie;